import {
    getMyLaborUnionService
    , getSettingService
} from '../../../../../services/modules/permisos-sindicales/v2/labor-union/service'

const state = () => ({
    myLaborUnions: []
    , setting: {
        value: 0
        , processing: false
    }
})

const mutations = {
    SET_MY_LABOR_UNION (state, data = []) {
        state.myLaborUnions = data
    }
    , SET_SETTING (state, { value = 0, processing = true }) {
        state.setting.value = value
        state.setting.processing = processing
    }
}

const actions = {
    async getMyLaborUnionAction ({ commit }) {
        const { result } = await getMyLaborUnionService().catch(({ response: { data : { message }}}) => alert(message))
        commit('SET_MY_LABOR_UNION', result)
    }
    , async getSettingAction ({ commit }, { id, key }) {
        commit('SET_SETTING', {})
        const { result } = await getSettingService({ id, key })
            .catch(({ response: { data : { message }}}) => alert(message))
        commit('SET_SETTING', { value: parseInt(result), processing: false })
    }
}

const getters = {
    getMyLaborUnionGetter: (state) => state.myLaborUnions
    , getSettingGetter: (state) => state.setting
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}